export default {
    currentOrganization: {},
    organizationsList: [],
};
